import { Controller } from "@hotwired/stimulus"
import { LogoHelper } from "~/helpers/logo_helper"

export default class extends Controller {
  connect() {
    const self = this

    $(this.element).autocomplete({
      noCache: false,
      minChars: 3,
      preserveInput: true,
      triggerSelectOnValidInput: false,
      lookup: self.lookup,
      formatResult: self.formatResult,
      onSelect: self.onSelect.bind(self),
    })
  }

  // Perform the lookup for the autocomplete and return suggestions
  lookup(query, done) {
    const items = []

    const input = App.hostnameFromURL(query)

    if (input === "") {
      return done({ suggestions: items })
    }

    return $.getJSON(App.api.domainsSuggestion(input), function (result) {
      result.data.forEach(function (item) {
        items.push({
          value: item.name,
          data: item.domain,
          logo: LogoHelper.companyLogoUrl(item.domain),
          email_count: item.email_count,
        })
      })

      done({ suggestions: items })
    })
  }

  // Format the suggestions for the autocomplete
  formatResult(suggestion, currentValue) {
    const dataHighlighted = suggestion.data.replace(
      currentValue.toLowerCase(),
      `<span class='suggestion-data-highlight'>${currentValue.toLowerCase()}</span>`,
    )

    let emailsCountClass = ""
    if (suggestion.email_count > 0) {
      emailsCountClass = "results-found"
    }

    let numberOfResults = i18n.t("js.front.domain_search.number_of_results", {
      count: suggestion.email_count,
      results_count: i18n.numberToDelimited(suggestion.email_count, {
        separator: i18n.translations[i18n.locale].js.number.format.separator,
        delimiter: i18n.translations[i18n.locale].js.number.format.delimiter,
      }),
    })

    let companyName = suggestion.data
    if (suggestion.value !== "") {
      companyName = suggestion.value
    }

    return `<span class="autocomplete-logo"><img src="${suggestion.logo}" onerror="this.src='/images/default_company_logo.svg'" /></span><span class="autocomplete-value">${companyName}</span><span class="autocomplete-data">${dataHighlighted}</span><span class="tag autocomplete-count ${emailsCountClass}">${numberOfResults}</span>`
  }

  // Fire the select event when a suggestion has been made
  onSelect(suggestion) {
    $(this.element).val(suggestion.data)
    this.dispatch("select", { detail: { domain: suggestion.data, name: suggestion.value } })
    return this.close()
  }

  close() {
    $(this.element).autocomplete("destroy")
  }
}
